module.exports = __webpack_public_path__ + "img/2.64857166.png";